function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.32 6.44a.5.5 0 00-.2-.87l-.79-.2a.5.5 0 01-.33-.7l.44-.89a.5.5 0 00-.58-.7l-2 .56a.5.5 0 01-.44-.08 5 5 0 00-8 4v.36a.25.25 0 01-.22.25c-2.81.33-5.5-1.1-8.4-4.44a.51.51 0 00-.51-.15A.5.5 0 002 4a7.58 7.58 0 00.46 4.92.25.25 0 01-.26.36l-1.12-.22a.5.5 0 00-.57.59 5.15 5.15 0 002.37 3.78.25.25 0 010 .45l-.53.21a.5.5 0 00-.26.69 4.36 4.36 0 003.2 2.48.25.25 0 010 .47c-1.36.562-2.819.845-4.29.83a.51.51 0 00-.2 1 20.06 20.06 0 008.14 1.93 12.58 12.58 0 007-2A12.5 12.5 0 0021.5 9.06v-.87a.5.5 0 01.18-.38l1.64-1.37z",
  fill: "currentColor"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.550ff66a.svg";
export { ForwardRef as ReactComponent };